import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { applyModeContent } from "../lib/modes";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PICKER_DEFAULTS = {
  eyebrow: "Welcome to CodingDrills by [Creator Academy](https://www.creatoracademy.edu.au)",
  heading: "How do you want to code?",
  subheading: "Three modes, three separate leaderboards. You can switch any time from the header.",
};

const ContentContext = createContext({ content: {}, loaded: false, version: 0, refresh: async () => {}, setContent: () => {} });

// Site copy the master admin can edit (mode picker, mode cards, plan cards). Overrides are merged over defaults.
export const ContentProvider = ({ children }) => {
  const [content, setContentState] = useState({});
  const [loaded, setLoaded] = useState(false);
  const [version, setVersion] = useState(0);

  const setContent = useCallback((next) => {
    applyModeContent(next?.modes || {});
    setContentState(next || {});
    setVersion((v) => v + 1);
  }, []);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch(`${API}/content`);
      if (res.ok) setContent(await res.json());
    } catch {
      /* defaults stay in place */
    } finally {
      setLoaded(true);
    }
  }, [setContent]);

  useEffect(() => { refresh(); }, [refresh]);

  return <ContentContext.Provider value={{ content, loaded, version, refresh, setContent }}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);

export const usePickerText = () => {
  const { content } = useContent();
  return { ...PICKER_DEFAULTS, ...(content.picker || {}) };
};

// Plan card copy: name, feature bullets and the "Most Popular" badge can be overridden
export const mergePlan = (key, plan, content) => {
  const o = (content.plans || {})[key] || {};
  return {
    ...plan,
    name: o.name || plan.name,
    features: Array.isArray(o.features) && o.features.length ? o.features : plan.features,
    popular: typeof o.popular === "boolean" ? o.popular : plan.popular,
  };
};
